export default __webpack_public_path__ + "static/media/bandeira.5756c393.png";